// extracted by mini-css-extract-plugin
export default {"main":"modalFullStats_main__-iQ1G"};